import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faMapLocationDot } from "@fortawesome/free-solid-svg-icons";
import './Summary.css';

function Summary(businessHours) {
    const date = new Date();
    date.setHours(date.getHours() - 2);
    return(
        <div id="summary">
            <h4>One of the best neighborhood Bar and Grills around, Our motto: "Come as you are".</h4>
            <a id="address" href="https://www.google.com/maps?cid=4652450288175630188" target="blank"><FontAwesomeIcon icon={faMapLocationDot} /> 3353 Fort St, Wyandotte, MI 48192</a>
            <a id="phone" href="tel:(734) 246-4240"><FontAwesomeIcon icon={faPhone} /> (734) 246-4240</a>
            <p id="openToday">Open today: {businessHours[date.getDay()]}</p>
        </div>
    )
}

export default Summary;
